import { Option } from '@/interfaces/option';
import { OptionResource, optionResource } from '@/resources/option.resource';
import { EntityModule } from './entity.module';

/**
 * Moduł Opcji
 *
 * @export
 * @class OptionModule
 * @extends {EntityModule<Option, OptionResource>}
 */
export class OptionModule extends EntityModule<Option, OptionResource> {
  constructor() {
    super(optionResource);
  }
}

export default new OptionModule();
